/* eslint-disable no-console */
import { log, supabase } from ".";

export const updateCliente = async (updatedData) => {
  try {
    const id = updatedData.id;
    delete updatedData.id; // Eliminar id del updatedData ya que se usa en el eq
    updatedData.lastupdate = new Date().toISOString(); // Add current timestamp to lastupdate
    const { data, error } = await supabase.update("clientes", updatedData, id);

    if (error) {
      throw error;
    }

    return data;
  } catch (error) {
    log.error("updateCliente", error);
    throw error;
  }
};
